import axiosIns from '@/api/axios';

const LIST_DEPARTMENT = (params) => {
	return axiosIns.get(`/plan-budget/list-department`);
};

const TRANSFER_TASK = (id, plan_id) => {
	return axiosIns.put(`/plan-budget/transfer/${id}?plan_id=${plan_id}`);
};

export { LIST_DEPARTMENT, TRANSFER_TASK };
